import * as types from '../actions/actionTypes'


const registrationReducer = (state = {
    actingAs: [],
    operatingStates: [], 
    rules: []
}, action) => {

    switch(action.type) {
      case types.GET_ALL_CLIENT_REGISTRATION_STUFF: 


      state = {
        ...state,
        actingAs: action.actingAs,
        operatingStates: action.operatingStates, 
        rules: action.rules,
      };
      break;
      case types.SET_CURRENT_COMPANY: 
        //if logging in with a different company wipe all of the store 
      state = {
        ...state,
        actingAs: action.payloadTwo ? state.actingAs : [],
        operatingStates: action.payloadTwo ? state.operatingStates : [], 
        rules: action.payloadTwo ? state.rules : []
      };
      break;
      default:
      break;    
    }

    return state;
};


export default registrationReducer;


// WEBPACK FOOTER //
// ./src/reducers/registrationReducer.js